import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { JWTService } from './JWTService';
import { AppState } from '../ngrx-store/app.state';
import { Observable } from 'rxjs';
import { v4 as uuid } from 'uuid';
import { NhanVien } from '../models/employees.model';
import { CuaHang_Store_CTQLocation, MaCQT, QuayBanCuaHang, TPC_QuayBan_MaCQT } from '../models/store_stalls.model';
import { ServerResponse } from '../models/types';
import { SoHD } from '../models/bill.model';
import * as localForage from 'localforage';
import { GetLocalForageConFigService } from './getLocalForage.service';
import { async } from '@angular/core/testing';
import * as moment from 'moment';
import { Result } from '@zxing/library';

@Injectable()
export class AuthenticationService {

  obs_NV: Observable<NhanVien[]>;
  dsNV: Array<NhanVien>;
  dtStore: QuayBanCuaHang = null;
  url = '';
  messageError = '';
  constructor(
    private http: HttpClient,
    private router: Router,
    private jwtService: JWTService,
    private appStore: Store<AppState>,
    private store: Store<NhanVien>,
    private storeQB: Store<QuayBanCuaHang>,
    private getlocalconfig: GetLocalForageConFigService,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this.url = baseUrl;
    this.obs_NV = this.appStore.select(state => state.dsnhanvien);
    this.obs_NV.subscribe(data => {
      if (data) {
        this.dsNV = data;
      } else {
        // const aes = localStorage.getItem('_dsNV');
        localForage.getItem('_dsNV').then(result => {
          if (result) {
            this.dsNV = JSON.parse(this.jwtService.deCryptData(result));
          }
          console.log(result);
        });
        // console.log('aes');
        // console.log(aes);
        // if (aes) {
        //   this.dsNV = JSON.parse(this.jwtService.deCryptData(aes));
        // }
      }
    });
  }
  async login(username: string, password: string, _isChecked: boolean) {
    this.dtStore = JSON.parse(localStorage.getItem('_dtQBan'))[0];
    console.log('this.dtStore')
    console.log(this.dtStore)
    if (window.navigator.onLine === true) {
      console.log('Dang nhap online');
      const data = {
        'username': username,
        'password': password,
        'MaCH': this.dtStore.MaCH
      };
      const jwt = await this.jwtService.Encode(data);
      return this.http.post(this.url + 'api/Auth/Login',
        { TokenCL: jwt })
        .toPromise()
        .then((result: ServerResponse) => {
          if (result[0].code === 1) {
            //var res = new NhanVien();
            const res: NhanVien = result[0].data;
            //return this.jwtService.Decode(result[0].data)
              //.then( (res: NhanVien) => {
                if (res.TenDangNhap !== 'admin') {
                  if (this.dtStore.MaCH === res.MaCH) {
                    if (res.TenDangNhap === 'admin' && _isChecked === true) {
                      this.getlocalconfig.getConfigLocalForage()
                        .then(async result => {
                          await localForage.setItem('_user', JSON.stringify(res));
                        });
                      this.store.dispatch({ type: 'ADD_USER', user: res });
                      this.router.navigate(['/quan-tri-cau-hinh']);
                    } else if (res.TenDangNhap !== 'admin' && _isChecked === true) {
                      throw new Error('Tài khoản của bạn không có quyền truy cập.');
                    } else {
                      this.getlocalconfig.getConfigLocalForage()
                        .then(async result => {
                          await localForage.setItem('_user', JSON.stringify(res));
                        });
                      this.store.dispatch({ type: 'ADD_USER', user: res });
                      this.router.navigate(['/banhang']);
                    }
                  } else {
                    throw new Error('Lỗi đăng nhập Client');
                  }
                }
                if (res.TenDangNhap === 'admin') {
                  if (res.TenDangNhap === 'admin' && _isChecked === true) {
                    this.getlocalconfig.getConfigLocalForage()
                      .then(async result => {
                        await localForage.setItem('_user', JSON.stringify(res));
                      });
                    this.store.dispatch({ type: 'ADD_USER', user: res });
                    this.router.navigate(['/quan-tri-cau-hinh']);
                  } else if (res.TenDangNhap !== 'admin' && _isChecked === true) {
                    throw new Error('Tài khoản của bạn không có quyền truy cập.');
                  } else {
                    this.getlocalconfig.getConfigLocalForage()
                      .then(async result => {
                        await localForage.setItem('_user', JSON.stringify(res));
                      });
                    this.store.dispatch({ type: 'ADD_USER', user: res });
                    this.router.navigate(['/banhang']);
                  }
                }
              //});
          } else if (result[0].code === 0) {
            throw (result[0].message);
          } else {
            throw (result[0].message);
          }
        });
    } else if (window.navigator.onLine === false) {
      console.log('Dang nhap offline');
      if (this.dsNV) {
        console.log(this.dsNV);
        console.log('Trace 1');
        const pw = this.jwtService.EncodePass(password);
        console.log(pw);
        console.log('Trace 1.1');
        const index = this.dsNV.find(x => x.TenDangNhap.toUpperCase() === username.toUpperCase() && x.MatKhau === pw);
        console.log('Trace 1.2');
        console.log(index);
        if (index) {
          console.log('Trace 2');
          const nv: NhanVien = {
            MaCH: index.MaCH,
            MaNV: index.MaNV,
            TenDangNhap: index.TenDangNhap,
            MatKhau: '',
            TenNV: index.TenNV,
            TrangThai: index.TrangThai
          };
          if (nv.TrangThai === 0) {
            throw ('Nhân viên không có quyền đăng nhập!');
          }
          if (nv.TenDangNhap === 'admin') {
            console.log('Trace 3');
            if (nv.TenDangNhap === 'admin' && _isChecked === true) {
              console.log('Trace 4');
              this.getlocalconfig.getConfigLocalForage()
                .then(async result => {
                  console.log('Trace 5');
                  await localForage.setItem('_user', JSON.stringify(nv));
                });
              this.store.dispatch({ type: 'ADD_USER', user: nv });
              this.router.navigate(['/quan-tri-cau-hinh']);
            } else if (index.TenDangNhap !== 'admin' && _isChecked === true) {
              console.log('Trace 6');
              throw new Error('Tài khoản của bạn không có quyền truy cập.');
            } else {
              console.log('Trace 7');
              this.getlocalconfig.getConfigLocalForage()
                .then(async result => {
                  console.log('Trace 8');
                  await localForage.setItem('_user', JSON.stringify(nv));
                });
              this.store.dispatch({ type: 'ADD_USER', user: nv });
              this.router.navigate(['/banhang']);
            }
          } else {
            console.log('Trace 9');
            if (this.dtStore.MaCH === index.MaCH) {
              console.log('Trace 10');
              if (nv.TenDangNhap === 'admin' && _isChecked === true) {
                console.log('Trace 11');
                this.getlocalconfig.getConfigLocalForage()
                  .then(async result => {
                    console.log('Trace 12');
                    await localForage.setItem('_user', JSON.stringify(nv));
                  });
                this.store.dispatch({ type: 'ADD_USER', user: nv });
                this.router.navigate(['/quan-tri-cau-hinh']);
              } else if (nv.TenDangNhap !== 'admin' && _isChecked === true) {
                console.log('Trace 12');
                throw new Error('Tài khoản của bạn không có quyền truy cập.');
              } else {
                console.log('Trace 13');
                console.log('Dang nhap offline nv thuong');
                this.getlocalconfig.getConfigLocalForage()
                  .then(async result => {
                    console.log('Trace 14');
                    await localForage.setItem('_user', JSON.stringify(nv));
                  });
                this.store.dispatch({ type: 'ADD_USER', user: nv });
                this.router.navigate(['/banhang']);
              }
            } else {
              console.log('Trace 15');
              throw new Error('Lỗi đăng nhập Client');
            }
          }
        }
        else {
          throw new Error('Tài khoản hoặc mật khẩu không chính xác!');
        }
      }
    }
  }

  async check_manager(username: string, password: string) {
      if (this.dsNV) {
        const pw = this.jwtService.EncodePass(password);
        const index = this.dsNV.find(x => x.TenDangNhap.toUpperCase() === username.toUpperCase() && x.MatKhau === pw);
        if (index) {
          const nv: NhanVien = {
            MaCH: index.MaCH,
            MaNV: index.MaNV,
            TenDangNhap: index.TenDangNhap,
            MatKhau: '',
            TenNV: index.TenNV,
            TrangThai: index.TrangThai,
            LoaiNV: index.LoaiNV
          };
          if (nv.LoaiNV === "Normal") {
            throw ('Nhân viên không có quyền thực hiện!');
          }
          else {              
            return true;
            }
          }        
        else {
          throw new Error('Tài khoản hoặc mật khẩu không chính xác!');
        }      
    }
  }
  //async checkUser(user: NhanVien) {
  //  return this.http.post(this.url + 'api/Auth/checkUser', {
  //    MaCH: user.MaCH, TenDangNhap: user.TenDangNhap, TenNV: user.TenNV, MaNV: user.MaNV, TrangThai: user.TrangThai
  //  }).toPromise()
  //    .then(result => {
  //      return result;
  //    })
  //    .catch(err => err);
  //}

  async force_logout() {
    this.store.dispatch({ type: 'LOGOUT_USER' });
    // localStorage.removeItem('_user');
    localForage.removeItem('_user');
    // localStorage.removeItem('_customer');
    localForage.removeItem('_customer');
    // localStorage.removeItem('_dsHD'); // test thử cái dưới
    localForage.removeItem('_dsHD');
    // localStorage.removeItem('_curHD');
    localForage.removeItem('_curHD');

    // localStorage.removeItem('_curHDDoi');
    localForage.removeItem('_curHDDoi');
    // localStorage.removeItem('_curHDTong');
    localForage.removeItem('_curHDTong');
    localStorage.removeItem('_dtQBan');
    // localForage.removeItem('_dtQBan');
    // localStorage.removeItem('_dsNV');
    localForage.removeItem('_dsNV');
    // localStorage.removeItem('_dsHH');
    localForage.removeItem('_dsHH');
    localForage.removeItem('_dsKHHCG');
    // localStorage.removeItem('_logID');
    localForage.removeItem('_logID');
    // localStorage.removeItem('_dsHTTT');
    localForage.removeItem('_dsHTTT');
    // localStorage.removeItem('_dsBill');
    localForage.removeItem('_dsBill');
    // localStorage.removeItem('_dsHD'); // test thử cái dưới
    localForage.removeItem('_dsHD');
    localForage.removeItem('_curSoHD');
    localForage.removeItem('_dsSKG');
    this.router.navigate(['/nhap-ma-quay']);
  }

  async logout() {
    // await this.outLog()
    //   .then(result => {
    this.store.dispatch({ type: 'LOGOUT_USER' });
    // localStorage.removeItem('_user');
    localForage.removeItem('_user');
    // localStorage.removeItem('_customer');
    localForage.removeItem('_customer');
    // localStorage.removeItem('_dsHD'); // test thử cái dưới
    localForage.removeItem('_dsHD');
    // localStorage.removeItem('_curHD');
    localForage.removeItem('_curHD');

    // localStorage.removeItem('_curHDDoi');
    localForage.removeItem('_curHDDoi');
    localForage.removeItem('_curHDDoi_Temp');
    localForage.removeItem('_curHDDoi_CQT_Temp');
    // localStorage.removeItem('_curHDTong');
    localForage.removeItem('_curHDTong');
    localForage.removeItem('_cashin');
    localForage.removeItem('_DSMaCQT_SaveOff');
    this.router.navigate(['/signin']);
    // });
  }
  async logout_ForMaCQT() {
    // await this.outLog()
    //   .then(result => {
    this.store.dispatch({ type: 'LOGOUT_USER' });
    // localStorage.removeItem('_user');
    localForage.removeItem('_user');
    // localStorage.removeItem('_customer');
    localForage.removeItem('_customer');
    // localStorage.removeItem('_dsHD'); // test thử cái dưới
    localForage.removeItem('_dsHD');
    // localStorage.removeItem('_curHD');
    localForage.removeItem('_curHD');

    // localStorage.removeItem('_curHDDoi');
    localForage.removeItem('_curHDDoi');
    localForage.removeItem('_curHDDoi_Temp');
    localForage.removeItem('_curHDDoi_CQT_Temp');
    // localStorage.removeItem('_curHDTong');
    localForage.removeItem('_curHDTong');
    localForage.removeItem('_cashin');
/*    this.router.navigate(['/signin']);*/
    // });
  }

  async logout_config() {
    this.store.dispatch({ type: 'LOGOUT_USER' });
    // localStorage.removeItem('_user');
    localForage.removeItem('_user');
    // localStorage.removeItem('_customer');
    localForage.removeItem('_customer');
    // localStorage.removeItem('_dsHD'); // test thử cái dưới
    localForage.removeItem('_dsHD');
    // localStorage.removeItem('_curHD');
    localForage.removeItem('_curHD');

    // localStorage.removeItem('_curHDDoi');
    localForage.removeItem('_curHDDoi');
    // localStorage.removeItem('_curHDTong');
    localForage.removeItem('_curHDTong');
    // localStorage.removeItem('_acceptKey');
    localForage.removeItem('_acceptKey');
    this.router.navigate(['/']);
  }

  out_to_quayban() {
    this.outLog();
    localStorage.removeItem('_dtQBan');
    // localForage.removeItem('_dtQBan');
    // localStorage.removeItem('_dsNV');
    localForage.removeItem('_dsNV');
    // localStorage.removeItem('_dsHH');
    localForage.removeItem('_dsHH');
    // localStorage.removeItem('_logID');
    localForage.removeItem('_logID');
    // localStorage.removeItem('_dsHTTT');
    localForage.removeItem('_dsHTTT');
    localForage.removeItem('_dsKHHCG');
    // localStorage.removeItem('_dsBill');
    localForage.removeItem('_dsBill');
    // localStorage.removeItem('_dsHD'); // test thử cái dưới
    localForage.removeItem('_dsHD');
    localForage.removeItem('_dsSKG');
    this.router.navigate(['/nhap-ma-quay']);
  }

async bin2String(array) {
  var result = "";
  for (var i = 0; i < array.length; i++) {
    result += String.fromCharCode(parseInt(array[i], 2));
  }
  return result;
}


  getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == '  ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  async getAccessDevice(uid: string) {
    return this.http.post(this.url + 'api/Auth/getAccess', { UID: uid })
      .toPromise()
      .then(async result => {
        if (result[0] === true) {
          await this.getlocalconfig.getConfigLocalForage()
            .then(async res => {
              await localForage.setItem('_acceptKey', uid)
            });
          this.router.navigate(['/nhap-ma-quay']);
          return uid;
        } else if (this.getCookie('_acceptKey') && this.getCookie('_acceptKey') !== uid) {
          throw new Error('ID bị đổi!');
        } else {
          throw new Error('Không có quyền truy cập!');
        }
      });
  }

  async getMaQuay(value: string) {
    // Check ngày server để kiểm tra ngày server với ngày trên máy POS nếu khác ngày thì khum cho vào trang đăng nhập
    var MACQT_CQT: MaCQT = new MaCQT();
    var CuaHangStoreCTQLocation: CuaHang_Store_CTQLocation = new CuaHang_Store_CTQLocation();
    const tDayPOS = moment();
    const tPOS = tDayPOS.format('DD');
    const tYearPOS = tDayPOS.format('YYYY');
    return await this.http.get(this.url + 'api/QuayBan_CuaHang/checkDaySubmitTill', {responseType: 'text'})
      .toPromise()
      .then(async day => {
        let getValueDay = day.toString().substring(0, 2);
        let getValueYear = day.toString().substring(2, 6);
        if (getValueDay == tPOS) {
          const id = uuid();
          // const uid_device = localStorage.getItem('_acceptKey');
          const uid_device = await localForage.getItem('_acceptKey').then(result => result);
          this.getlocalconfig.getConfigLocalForage()
            .then(async result => {
              await localForage.setItem('_logID', JSON.stringify({ id: id, key: value, uid_device: uid_device }));
            });
          return await this.http.post(this.url + 'api/QuayBan_CuaHang/checkKey_QBan', { Key: value, Id: id, UID_device: uid_device, ROW_id: id })
            .toPromise()
            .then(async (result: ServerResponse) => {
              if (result[0].code === 1) {
                if (result[0].data === null) {
                  throw new Error('Mã quầy không tồn tại!');
                } else {
                  this.storeQB.dispatch({ type: 'ADD_STORE', store: result[0].data[0] });
                  localStorage.setItem('_dtQBan', JSON.stringify(result[0].data[0]));
                  // localForage.setItem('_dtQBan', JSON.stringify(result[0].data[0]));
                  // Lấy quầy bán từ local
                  let _dtQBan: QuayBanCuaHang = JSON.parse(localStorage.getItem('_dtQBan'));
                  if (getValueYear == tYearPOS) {
                    let _MaQuayTemp = await localForage.getItem('_MaQuayTemp').then(result => result)
                    if (_MaQuayTemp == _dtQBan[0].MaQuay || _MaQuayTemp == null) {
                      localForage.setItem("_MaQuayTemp", _dtQBan[0].MaQuay);
                      // Kiểm tra bảng có dữ liệu đó không / Nếu không có thì xét bằng 0 / Nếu có thì lấy MACQT dữ liệu ra + 1
                      await this.GetStore_CQTLocation(_dtQBan[0].MaQuay).then((result: any) => {
                        console.log("CuaHangStoreCTQLocation : " + result[0])
                        // Check TPC_Till
                        CuaHangStoreCTQLocation = {
                          CQT_Location: result[0].cqT_Location,
                          StoreID: result[0].storeID,
                          TillID: result[0].tillID
                        }
                      });
                      await this.http.post(this.url + 'api/QuayBan_CuaHang/checkQuayBan_MaCQT', { Store: _dtQBan[0].MaQuay, Year: tYearPOS })
                        .toPromise()
                        .then(result => {
                          if (result[0] == null) {
                            MACQT_CQT = {
                              MaCQT: 0,
                              MaKhuVuc: _dtQBan[0].MaKhuVuc,
                              MaQuay: _dtQBan[0].MaQuay,
                              Nam: tYearPOS,
                              TenQuay: _dtQBan[0].TenQuay,
                              CQT_location: CuaHangStoreCTQLocation.CQT_Location,
                              StoreID: CuaHangStoreCTQLocation.StoreID
                            }
                            this.getlocalconfig.getConfigLocalForage()
                              .then(async result => {
                                await localForage.setItem('_MaCQT', JSON.stringify(MACQT_CQT))
                                await localForage.setItem("_MaQuayTemp", _dtQBan[0].MaQuay);
                              });
                          } else {
                            if (result[0].macqt === "99999") {
                              throw new Error('Mã cơ quan thuế vượt quá số lượng.');
                            } else if (result[0].maCQT_Location !== CuaHangStoreCTQLocation.CQT_Location) {
                              // Nếu có dữ liệu thì sẽ get giá trị đó
                              console.log("Có dữ liệu cho phần check Quầy MACQT : " + result[0])
                              MACQT_CQT = {
                                MaCQT: result[0].macqt,
                                MaKhuVuc: _dtQBan[0].MaKhuVuc,
                                MaQuay: _dtQBan[0].MaQuay,
                                Nam: result[0].year,
                                TenQuay: _dtQBan[0].TenQuay,
                                CQT_location: CuaHangStoreCTQLocation.CQT_Location,
                                StoreID: CuaHangStoreCTQLocation.StoreID
                              }
                              this.getlocalconfig.getConfigLocalForage()
                                .then(async result => {
                                  await localForage.setItem('_MaCQT', JSON.stringify(MACQT_CQT))
                                  await localForage.setItem("_MaQuayTemp", _dtQBan[0].MaQuay);
                                });
                            } else {
                              // Nếu có dữ liệu thì sẽ get giá trị đó
                              console.log("Có dữ liệu cho phần check Quầy MACQT : " + result[0])
                              MACQT_CQT = {
                                MaCQT: result[0].macqt,
                                MaKhuVuc: _dtQBan[0].MaKhuVuc,
                                MaQuay: _dtQBan[0].MaQuay,
                                Nam: result[0].year,
                                TenQuay: _dtQBan[0].TenQuay,
                                CQT_location: CuaHangStoreCTQLocation.CQT_Location,
                                StoreID: CuaHangStoreCTQLocation.StoreID
                              }
                              this.getlocalconfig.getConfigLocalForage()
                                .then(async result => {
                                  await localForage.setItem('_MaCQT', JSON.stringify(MACQT_CQT))
                                  await localForage.setItem("_MaQuayTemp", _dtQBan[0].MaQuay);
                                });
                            }
                          }
                        })
                    } else {
                      // Kiểm tra bảng có dữ liệu đó không / Nếu không có thì xét bằng 0 / Nếu có thì lấy MACQT dữ liệu ra + 1
                      await this.GetStore_CQTLocation(_dtQBan[0].MaQuay).then((result: any) => {
                        console.log("CuaHangStoreCTQLocation : " + result[0])
                        CuaHangStoreCTQLocation = {
                          CQT_Location: result[0].cqT_Location,
                          StoreID: result[0].storeID,
                          TillID: result[0].tillID
                        }
                      });
                      await this.http.post(this.url + 'api/QuayBan_CuaHang/checkQuayBan_MaCQT', { Store: _dtQBan[0].MaQuay, Year: tYearPOS })
                        .toPromise()
                        .then(result => {
                          if (result[0] == null) {
                            MACQT_CQT = {
                              MaCQT: 0,
                              MaKhuVuc: _dtQBan[0].MaKhuVuc,
                              MaQuay: _dtQBan[0].MaQuay,
                              Nam: tYearPOS,
                              TenQuay: _dtQBan[0].TenQuay,
                              CQT_location: CuaHangStoreCTQLocation.CQT_Location,
                              StoreID: CuaHangStoreCTQLocation.StoreID
                            }
                            this.getlocalconfig.getConfigLocalForage()
                              .then(async result => {
                                await localForage.setItem('_MaCQT', JSON.stringify(MACQT_CQT))
                                await localForage.setItem("_MaQuayTemp", _dtQBan[0].MaQuay);
                              });
                          } else {
                            if (result[0].macqt === "99999") {
                              throw new Error('Mã cơ quan thuế vượt quá số lượng.');
                            } else if (result[0].maCQT_Location !== CuaHangStoreCTQLocation.CQT_Location) {
                              // Nếu có dữ liệu thì sẽ get giá trị đó
                              console.log("Có dữ liệu cho phần check Quầy MACQT : " + result[0])
                              MACQT_CQT = {
                                MaCQT: result[0].macqt,
                                MaKhuVuc: _dtQBan[0].MaKhuVuc,
                                MaQuay: _dtQBan[0].MaQuay,
                                Nam: result[0].year,
                                TenQuay: _dtQBan[0].TenQuay,
                                CQT_location: CuaHangStoreCTQLocation.CQT_Location,
                                StoreID: CuaHangStoreCTQLocation.StoreID
                              }
                              this.getlocalconfig.getConfigLocalForage()
                                .then(async result => {
                                  await localForage.setItem('_MaCQT', JSON.stringify(MACQT_CQT))
                                  await localForage.setItem("_MaQuayTemp", _dtQBan[0].MaQuay);
                                });
                            } else {
                              // Nếu có dữ liệu thì sẽ get giá trị đó
                              console.log("Có dữ liệu cho phần check Quầy MACQT : " + result[0])
                              MACQT_CQT = {
                                MaCQT: result[0].macqt,
                                MaKhuVuc: _dtQBan[0].MaKhuVuc,
                                MaQuay: _dtQBan[0].MaQuay,
                                Nam: result[0].year,
                                TenQuay: _dtQBan[0].TenQuay,
                                CQT_location: CuaHangStoreCTQLocation.CQT_Location,
                                StoreID: CuaHangStoreCTQLocation.StoreID
                              }
                              this.getlocalconfig.getConfigLocalForage()
                                .then(async result => {
                                  await localForage.setItem('_MaCQT', JSON.stringify(MACQT_CQT))
                                  await localForage.setItem("_MaQuayTemp", _dtQBan[0].MaQuay);
                                });
                            }
                          }
                        })
                    }
                 } else {
                    MACQT_CQT = {
                      MaCQT: 0,
                      MaKhuVuc: _dtQBan.MaKhuVuc,
                      MaQuay: _dtQBan.MaQuay,
                      Nam: tYearPOS,
                      TenQuay: _dtQBan[0].TenQuay,
                      CQT_location: CuaHangStoreCTQLocation.CQT_Location,
                      StoreID: CuaHangStoreCTQLocation.StoreID
                    }
                    this.getlocalconfig.getConfigLocalForage()
                      .then(async result => {
                        await localForage.setItem('_MaCQT', JSON.stringify(MACQT_CQT))
                        await localForage.setItem("_MaQuayTemp", _dtQBan[0].MaQuay);
                      });
                 }
                  const SoHDMax = result[0].data[1];
                  if (SoHDMax !== -1) {
                    const now = new Date();
                    const HDMax: SoHD = {
                      SoHD: SoHDMax,
                      NgayLapHD: now
                    };
                    this.getlocalconfig.getConfigLocalForage()
                      .then(async result => {
                        await localForage.setItem('_curSoHD', JSON.stringify(HDMax)).then();
                        await localForage.setItem('_curSoHD_Temp', JSON.stringify(HDMax)).then();
                      });
                  }
                  this.router.navigate(['/signin']);
                  return result[0].data[0];
                }
              } else if (result[0].code === 2) {
                await this.http.post(this.url + 'api/QuayBan_CuaHang/checkQuayBan_MaCQT', { Store: value, Year: tYearPOS })
                  .toPromise()
                  .then(qbmacqt => {
                    if (qbmacqt[0] == null) {
                      throw new Error(result[0].message);
                    } else if (qbmacqt[0].macqt === "99999") {
                      throw new Error('Mã cơ quan thuế vượt quá số lượng.');
                    } else {
                      throw new Error(result[0].message);
                    }
                  })
              } else if (result[0].code === 0) {
                await this.http.post(this.url + 'api/QuayBan_CuaHang/checkQuayBan_MaCQT', { Store: value, Year: tYearPOS })
                  .toPromise()
                  .then(qbmacqt => {
                    if (qbmacqt[0] == null) {
                      throw new Error(result[0].message);
                    } else if (qbmacqt[0].macqt === "99999") {
                      throw new Error('Mã cơ quan thuế vượt quá số lượng.');
                    } else {
                      throw new Error(result[0].message);
                    }
                  })
              }
            });
        } else {
          throw new Error('Không đăng nhập vào phần mềm được do ngày giờ đang bị chênh lệch. Vui lòng kiểm tra lại ngày giờ của máy.');
        }
      });
  }


  async GetNumber_Maxbill_Again(value: string) {
    // Check ngày server để kiểm tra ngày server với ngày trên máy POS nếu khác ngày thì khum cho vào trang đăng nhập
    const id = uuid();
    const uid_device = await localForage.getItem('_acceptKey').then(result => result);
    return await this.http.post(this.url + 'api/QuayBan_CuaHang/checkNumber_Maxbill_Again', { Key: value, Id: id, UID_device: uid_device, ROW_id: id })
      .toPromise()
      .then(async (result: ServerResponse) => {
        const SoHDMax = result[0].data[0];
        if (SoHDMax == -2 || SoHDMax == -1) {
          const now = new Date();
          const HDMax: SoHD = {
            SoHD: SoHDMax,
            NgayLapHD: now
          };
          return HDMax;
        }
        else if (SoHDMax !== -1 || SoHDMax !== -2) {
          const now = new Date();
          const HDMax: SoHD = {
            SoHD: SoHDMax,
            NgayLapHD: now
          };
          this.getlocalconfig.getConfigLocalForage()
            .then(async result => {
              await localForage.setItem('_curSoHD', JSON.stringify(HDMax)).then();
              await localForage.setItem('_curSoHD_Temp', JSON.stringify(HDMax)).then();
            });
          return HDMax;
        }
      });
  }

  async check_force_logout() {
    var past_log;
    await this.getlocalconfig.getConfigLocalForage()
      .then(async result => {
        await localForage.getItem('_logID').then(async (result: string) => {
          past_log = await JSON.parse(result);
          return await this.http.post(this.url + 'api/QuayBan_CuaHang/checkKey_QBan_OutDated',
            { Key: past_log.key, Id: past_log.id, UID_device: past_log.uid_device, ROW_id: past_log.id })
            .toPromise()
            .then((result1: ServerResponse) => {
              if (result1[0].code === 1) {
                throw new Error(result1[0].message);
              } else if (result1[0].code === 2) {
                return;
              }
            });
        });
      });

  }

  async outLog() {
    // const Log = JSON.parse(localStorage.getItem('_logID'));
    localForage.getItem('_logID').then((data: any) => {
      const Log = JSON.parse(data);
      if (Log) {
        return this.http.post(this.url + 'api/QuayBan_CuaHang/outLog', { Id: Log.id, Key: Log.key, UID_device: Log.key }).toPromise()
          .then((result: ServerResponse) => {
            if (result[0].code === 1) {
              // localStorage.removeItem('_logID');
              // localForage.removeItem('_logID');
            } else {
              alert('Out Log thất bại!');
              throw new Error('Out Log thất bại');
            }
          })
          .catch(err => console.log(err));
      }
    });
  }

  // async loginUser(username: string, password: string) {
  //   const data = {
  //     'username': username,
  //     'password': password
  //   };
  //   const jwt = await this.jwtService.Encode(data);
  //   return this.http.post(this.url + 'api/Auth/LoginAdmin',
  //   { TokenCL: jwt })
  //   .toPromise()
  //   .then((result: ServerResponse) => {
  //     if (result[0].code === 1) {
  //       return this.jwtService.Decode(result[0].data)
  //       .then (res => {
  //           localStorage.setItem('_user', JSON.stringify(res));
  //           this.router.navigate(['/quan-tri-cau-hinh']);
  //       });
  //     } else if (result[0].code === 0) {
  //       throw new Error(result[0].message);
  //     } else {
  //       throw new Error(result[0].message);
  //     }
  //   });
  // }
  redirectTPA(uid: string) {
    this.http.get('manifest.json', { responseType: 'json' }).subscribe(async name => {
      const urlTPA: string = await name['config_uid_admin'];
      // const urlTPA_UID = urlTPA.replace(':uid', uid);
      const urlTPA_UID = urlTPA + '/auth/check-uid/' + uid;
      window.location.href = urlTPA_UID;
    });
  }

  // Check Till
  async GetStore_CQTLocation(TillID: string) {
    return await this.http.post(this.url + 'api/QuayBan_CuaHang/checkCuaHang_Store_CTQLocation', { TillID: TillID })
      .toPromise()
      .then(result => {
        return result;
      })
      .catch(err => {
        console.log("Lỗi GetStore_CQTLocation : " + err)
      })
  }

  //Check QuayBan_MACQT
  async getQuayBan_MaCQT(Register: string) {
    return await this.http.post(this.url + 'api/QuayBan_CuaHang/checkQuayBan_MaCQT', { Store: Register })
      .toPromise()
      .then(result => {
        return result;
      })
      .catch(err => {
        console.log("Lỗi getQuayBan_MaCQT : " + err)
      })
  }

  //Cập nhật lại QuayBan_MaCQT
  async UpdateQuayBan_MaCQT_Logout(TPCQuayBanMaCQT: TPC_QuayBan_MaCQT) {
    await this.http.post(this.url + 'api/HoaDon/Insert_Update_QuayBanMaCQT', {
      Store: TPCQuayBanMaCQT.Store,
      Register: TPCQuayBanMaCQT.Register,
      Year: TPCQuayBanMaCQT.Year,
      MACQT: TPCQuayBanMaCQT.MACQT,
      Update_Date: TPCQuayBanMaCQT.Update_Date,
      CQT_Location: TPCQuayBanMaCQT.CQT_Location
    })
      .toPromise()
      .then(result => {
        return result;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts